import { useDialog } from "@/hooks/useDialog";

/**
 * Guards closing a form modal (cancel button / backdrop / ESC): closes immediately when the form
 * is pristine, otherwise asks for confirmation first. Render `<ConfirmSaveModal>` with `confirmClose`.
 */
export const useConfirmCloseModal = (isDirty: boolean, onClose: () => void) => {
  const confirmClose = useDialog();

  const handleRequestClose = async () => {
    if (!isDirty) {
      onClose();
      return;
    }
    const isConfirmed = await confirmClose.show();
    if (isConfirmed) {
      onClose();
    }
  };

  return { confirmClose, handleRequestClose };
};
